export default __webpack_public_path__ + "static/media/5.03dcbe0e.jpg";